<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h1>Забыли пароль?</h1>
                <p class="text-muted">Вы можете восстановить его здесь.</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>@</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Email" autocomplete="email" />
                </b-input-group>
                <b-button variant="success" block>Отправить</b-button>
              </b-form>
            </b-card-body>
            <b-card-footer class="p-4">
              <small>
                Вы получите письмо с инструкциями для смены пароля.<br/>
                Вспомнили пароль? Вернитесь к <router-link to="/pages/login">авторизации.</router-link>
              </small>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Register'
}
</script>
